var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CustomDrawer',{ref:"CustomDrawer",attrs:{"title":"设置权限"},on:{"openedCallback":_vm.openedCallback,"handleConfirm":_vm.handleConfirm}},[_c('el-tree',{ref:"ElTree",attrs:{"data":_vm.allData,"node-key":"id","highlight-current":"","default-expand-all":"","show-checkbox":"","props":{
      label: 'title',
      children: 'child'
    },"render-content":_vm.renderContent},on:{"node-expand":_vm.nodeExpand}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }